'use client';
const IDENT_INPUT_PLACEHOLDER = 'InputPlaceholder';
const defaultProps = {};

export { IDENT_INPUT_PLACEHOLDER, defaultProps };
//# sourceMappingURL=InputPlaceholder.contract.js.map
